var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "slider-core"
  }, [_vm._m(0), _c('div', {
    staticClass: "main-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "heading-3-large"
  }, [_vm._v(_vm._s(_vm.mainTitle))]), _c('div', {
    staticClass: "lead-1",
    domProps: {
      "innerHTML": _vm._s(_vm.mainDescription)
    }
  })]), _vm._m(2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "arrow-icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/arrow-long-slider.svg"),
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("../../assets/logo/seu-logo-square.svg")
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "arrow-icon-container arrow-bottom"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/arrow-long-slider.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }